import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";

type Props = {
    averagePosition: number | undefined;
    websiteGuid: string;
};

export default function TopKeywordsSummary({ averagePosition, websiteGuid }: Props) {
    const navigate = useNavigate();
    const handleViewReport = () => {
        navigate(`/top-keywords?w_guid=${websiteGuid}`);
    };

    return (
        <div className="dashboard-summary-section">
            <div className="container">
                <div className="dashboard-summary-section-title">
                    <span>Avg. position</span>
                    <Tooltip className="summary-tooltip" title="Average position of your domain in Top 100 keywords.">
                        <Icon type="question-circle" />
                    </Tooltip>
                </div>
                <div className="dashboard-summary-section-result">
                    {averagePosition ? (
                        <>
                            <Icon type="vertical-align-middle" />
                            <span>{averagePosition.toFixed(2)}</span>
                        </>
                    ) : (
                        <span>No data</span>
                    )}
                </div>
            </div>
            {averagePosition ? (<div className="view-report-btn" onClick={handleViewReport}>
                <span>View report</span>
                <Icon type="right" />
            </div>) : null}
        </div>
    );
}
